<ng-container *ngIf="userData?.email">
  <!-- Mobile top bar with hamburger -->
  <div class="mobile-topbar">
    <button type="button"
            class="hamburger"
            (click)="toggle()"
            [attr.aria-label]="isOpen ? 'Close menu' : 'Open menu'"
            [class.is-open]="isOpen">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <a class="mobile-brand" routerLink="/account">
      <img src="assets/totalum-logo-recortado.png" alt="Totalum" />
      <span>{{ 'TOTALUM_ACCOUNT_MANAGER' | translate }}</span>
    </a>
  </div>

  <!-- Backdrop (mobile only, when drawer open) -->
  <div class="sidebar-backdrop" [class.show]="isOpen" (click)="close()"></div>

  <!-- Sidebar / aside -->
  <aside class="sidebar" [class.open]="isOpen">
    <!-- Brand -->
    <a class="brand" routerLink="/account">
      <img src="assets/totalum-logo-recortado.png" alt="Totalum Logo" />
      <span class="brand-name">{{ 'TOTALUM_ACCOUNT_MANAGER' | translate }}</span>
    </a>

    <!-- Primary navigation -->
    <nav class="nav">
      <a class="nav-item" routerLink="/account" [class.active]="isActive('/account')">
        <i class="fa-solid fa-table-cells-large"></i>
        <span>{{ 'YOUR_PROJECTS' | translate }}</span>
      </a>

      <a class="nav-item" routerLink="/vcaas" [class.active]="isActive('/vcaas')">
        <i class="fa-solid fa-code"></i>
        <span>{{ 'vcaas.nav' | translate }}</span>
      </a>

      <a class="nav-item" routerLink="/mcp" [class.active]="isActive('/mcp')">
        <i class="fa-solid fa-plug"></i>
        <span>{{ 'mcp.nav' | translate }}</span>
      </a>

      <a *ngIf="isAdmin" class="nav-item" routerLink="/support-chat" [class.active]="isActive('/support-chat')">
        <i class="fa-solid fa-headset"></i>
        <span>Support Chat</span>
      </a>

      <ng-container *ngIf="isAdmin">
        <div class="nav-section-label">CEO</div>

        <a class="nav-item" routerLink="/ceo/dashboard" [class.active]="isActive('/ceo/dashboard')">
          <i class="fa-solid fa-chart-line"></i>
          <span>Dashboard</span>
        </a>

        <a class="nav-item" routerLink="/ceo/users" [class.active]="isActive('/ceo/users')">
          <i class="fa-solid fa-users"></i>
          <span>Users</span>
        </a>

        <a class="nav-item" routerLink="/ceo/projects" [class.active]="isActive('/ceo/projects')">
          <i class="fa-solid fa-diagram-project"></i>
          <span>Projects</span>
        </a>

        <!-- Email campaigns to filtered audiences + the quick-reply templates used by
             the "Contact" button in the customer panel. -->
        <a class="nav-item" routerLink="/ceo/emails" [class.active]="isActive('/ceo/emails')">
          <i class="fa-solid fa-paper-plane"></i>
          <span>Emails</span>
        </a>

        <!-- The Claude OAuth worker fleet (health, sign-ins, API credit balance). The page
             already existed at /ceo/oauths but was only reachable from a dashboard button. -->
        <a class="nav-item" routerLink="/ceo/oauths" [class.active]="isActive('/ceo/oauths')">
          <i class="fa-solid fa-key"></i>
          <span>OAuth</span>
        </a>

        <!-- The signup email-domain blocklist. Stored on account-backend, enforced on every
             front door (platform email/password, platform Google, legacy magic link). -->
        <a class="nav-item" routerLink="/ceo/block" [class.active]="isActive('/ceo/block')">
          <i class="fa-solid fa-ban"></i>
          <span>Block</span>
        </a>

        <!-- Free accounts (excluding internal): delete every project and zero the credits in bulk. -->
        <a class="nav-item" routerLink="/ceo/free-cleanup" [class.active]="isActive('/ceo/free-cleanup')">
          <i class="fa-solid fa-broom"></i>
          <span>Free cleanup</span>
        </a>

        <!-- The credit price list (credits_packs): create, edit, activate, delete. -->
        <a class="nav-item" routerLink="/ceo/credits-packs" [class.active]="isActive('/ceo/credits-packs')">
          <i class="fa-solid fa-coins"></i>
          <span>Credit packs</span>
        </a>

        <!-- The v2 engine: releases, pool, errors, runs, usage, overrides, rollout (plan 16). -->
        <a class="nav-item" routerLink="/ceo/v2" [class.active]="isActive('/ceo/v2')">
          <i class="fa-solid fa-rocket"></i>
          <span>Engine v2</span>
        </a>
      </ng-container>

      <a class="nav-item" routerLink="/user-data" [class.active]="isActive('/user-data')">
        <i class="fa-solid fa-gear"></i>
        <span>{{ 'SETTINGS' | translate }}</span>
      </a>

      <a class="nav-item" routerLink="/affiliate" [class.active]="isActive('/affiliate')">
        <i class="fa-solid fa-gift"></i>
        <span>{{ 'AFFILIATE' | translate }}</span>
      </a>
    </nav>

    <!-- Footer: language + user -->
    <div class="sidebar-footer">
      <div class="lang-block">
        <span class="lang-label">
          <i class="fa-solid fa-globe"></i>
          {{ 'LANGUAGE' | translate }}
        </span>
        <div class="lang-switch" role="group" aria-label="Language">
          <button type="button"
                  class="lang-option"
                  [class.active]="currentLang === 'en'"
                  (click)="setLanguage('en')">EN</button>
          <button type="button"
                  class="lang-option"
                  [class.active]="currentLang === 'es'"
                  (click)="setLanguage('es')">ES</button>
        </div>
      </div>

      <div class="user-chip">
        <div class="user-avatar">{{ userInitial }}</div>
        <div class="user-meta">
          <span class="user-name" *ngIf="userFirstName">{{ userFirstName }}</span>
          <span class="user-email">{{ userData?.email }}</span>
        </div>
      </div>
    </div>
  </aside>
</ng-container>
